<template>
  <svg
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 9.59 5.62"
    aria-hidden="true"
  >
    <path d="M4.8 3.15L.02-.02V2.5L4.8 5.61 9.61 2.5V-.02z" />
  </svg>
</template>
